import type {AnalyticsInsightCard, AnalyticsInsightCardDTO} from './types';

/** Нормализует ответ API, сохраняя from в UI и в фильтрах запроса. */
export const adaptAnalyticsInsight = (
  card: AnalyticsInsightCardDTO,
): AnalyticsInsightCard => ({
  ...card,
  team: card.team ?? null,
  myState: card.myState ?? null,
  period: {from: card.period.from_, to: card.period.to},
});
